import { createFileRoute } from "@tanstack/react-router";
import { ProjectIndexRedirect } from "../../../../../pages/project-index-redirect/project-index-redirect";

export const Route = createFileRoute("/_auth/_deal/deals/$dealId/details/")({
  component: () => <ProjectIndexRedirect isInDealContext />,
});
